
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.867 14.836A4.61 4.61 0 0118 14.302v3.396a4.61 4.61 0 01-1.133-.534C16.138 16.68 16 16.228 16 16c0-.228.139-.679.867-1.164zM22 25.698v-3.396c.441.143.824.327 1.133.534.729.485.867.936.867 1.164 0 .228-.139.679-.867 1.164a4.61 4.61 0 01-1.133.534z","fill":"#fff","fill-opacity":".5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 36c8.837 0 16-7.163 16-16S28.837 4 20 4 4 11.163 4 20s7.163 16 16 16zm2-26a2 2 0 10-4 0v.184c-1.243.234-2.393.684-3.352 1.324C13.205 12.47 12 14.018 12 16c0 1.981 1.205 3.53 2.648 4.492.959.64 2.109 1.09 3.352 1.324v3.883c-.782-.254-1.362-.635-1.687-1.01a2 2 0 00-3.02 2.622c1.124 1.296 2.826 2.15 4.707 2.504V30a2 2 0 004 0v-.184c1.243-.233 2.393-.684 3.352-1.323C26.795 27.53 28 25.98 28 24c0-1.981-1.205-3.53-2.648-4.492-.959-.64-2.109-1.09-3.352-1.324v-3.883c.782.254 1.362.635 1.687 1.01a2 2 0 003.02-2.622c-1.124-1.296-2.826-2.15-4.707-2.504V10z","fill":"#fff","fill-opacity":".5"}})])
          )
        }
      }
    